import PropTypes from 'prop-types';
import React from 'react';
import { CONSENT_OPTIONS } from '../../constants';
var ConsentDropzoneMessage = function ConsentDropzoneMessage(_ref) {
  var type = _ref.type;
  switch (type) {
    case CONSENT_OPTIONS.DOCUMENT:
      return /*#__PURE__*/React.createElement("p", null, "Drop signed consent form to attach or ", /*#__PURE__*/React.createElement("a", null, "browse"));
    case CONSENT_OPTIONS.AUDIO:
      return /*#__PURE__*/React.createElement("p", null, "Drop audio consent file to attach or ", /*#__PURE__*/React.createElement("a", null, "browse"));
    default:
      return /*#__PURE__*/React.createElement("p", null, "Drop file to attach or ", /*#__PURE__*/React.createElement("a", null, "browse"));
  }
};
ConsentDropzoneMessage.propTypes = {
  type: PropTypes.string
};
export default ConsentDropzoneMessage;
//# sourceMappingURL=ConsentDropzoneMessage.js.map